import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  IconWrapper,
  StyledAccordion,
  AccordionSummary,
  AccordionDetails,
  AccordionContent,
  ArrowIcon,
} from './Accordion.styled';

const Accordion = ({ summary, isOpen, onClick, children, label, classes }) => {
  const [hasOpened, setHasOpened] = useState(false);

  useEffect(() => {
    if (isOpen && !hasOpened) {
      setHasOpened(true);
    }
  }, [isOpen, hasOpened]);

  return (
    <StyledAccordion expanded={isOpen}>
      <AccordionSummary onClick={onClick} aria-label={label}>
        <IconWrapper>
          <ArrowIcon isOpen={isOpen} />
        </IconWrapper>
        <div style={classes.summary}>{summary}</div>
      </AccordionSummary>
      <AccordionDetails>
        <AccordionContent>{(isOpen || hasOpened) && children}</AccordionContent>
      </AccordionDetails>
    </StyledAccordion>
  );
};

Accordion.propTypes = {
  summary: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  label: PropTypes.string,
  classes: PropTypes.shape({
    summary: PropTypes.string,
  }),
};

Accordion.defaultProps = {
  label: undefined,
  classes: {},
};

export default Accordion;
